import { createEntityFilterStore } from "./createEntityFilterStore";
import type { BeneficiaryFilters } from "@/domain/types";

const initialFilters: BeneficiaryFilters = {
	search: "",
	status: "",
	sector: "",
	sort: { key: undefined, direction: null },
};

export const useBeneficiaryFiltersStore =
	createEntityFilterStore<BeneficiaryFilters>(
		"BeneficiaryFiltersStore",
		initialFilters,
	);
